import Actions, { types } from "./action";
import { recorderStateType } from ".";

const initialState: recorderStateType = {
  recorder: {}
};

const reducer = (state = initialState, action: Actions): recorderStateType => {
  const newState = { ...state };
  switch (action.type) {
    case types.SET_RECORDER:
      newState.recorder = action.payload;
      return newState;
      
    default:
      return state;
  }
};

export default reducer;
